import { render, staticRenderFns } from "./WhoIsOnLeaveDashboard.vue?vue&type=template&id=e5c27848"
import script from "./WhoIsOnLeaveDashboard.vue?vue&type=script&lang=js"
export * from "./WhoIsOnLeaveDashboard.vue?vue&type=script&lang=js"
import style0 from "./WhoIsOnLeaveDashboard.vue?vue&type=style&index=0&id=e5c27848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports